import React from 'react';
import defaultPhone from '../assets/phone/phone-hero.png';
import logo from '../assets/logo/Selal_Logo.png';
import { Link } from 'react-router-dom';
import { useLang } from '../context/langcontext';

const Hero = ({
  heroImage = defaultPhone,
  showButtons = true,
  buttons = [
    { key: "contact", link: "/contact" },
    { key: "register", link: "/register" }
  ],
  hideButtons = [], // ✅ keys of buttons to hide
  customHeading,
  customSubtext,
  customDescription,
  showHeading = true,
  showLogo = true // ✅ new prop, default true
}) => {
  const { t } = useLang();

  // Filter out hidden buttons
  const visibleButtons = buttons.filter(btn => !hideButtons.includes(btn.key));

  return (
    <section className="hero">
      <div className="hero-content">
        {/* Show logo only if enabled */}
        {showLogo && <img src={logo} alt="Selal Logo" className="hero-logo" />}

        {/* Heading */}
        {showHeading && (
          <h1>{customHeading || t("heroHeading")}</h1>
        )}

        {/* Subtext */}
        <p className="hero-subtext">{customSubtext || t("heroSubtext")}</p>

        {/* Description */}
        <p className="hero-description">{customDescription || t("heroDescription")}</p>

        {/* Buttons */}
        {showButtons && visibleButtons.length > 0 && (
          <div className="download-btns">
            {visibleButtons.map((btn, index) => (
              <Link key={index} to={btn.link} className="hero-btn">
                {t(btn.key)}
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* Phone image */}
      <img src={heroImage} alt="" className="phone" />
    </section>
  );
};

export default Hero;
